// lib/site/consumerNav.ts
// Puro: lo importan componentes cliente y servidor. Dónde vive "Inicio" depende
// del host: en redytoeat la raíz ES el marketplace; en useredy, preview y local
// la raíz es el sitio de marketing y el marketplace vive en /order.
import { isConsumerHost } from "@/lib/site/consumerHost"

export function consumerHomeHref(host: string): string {
  return isConsumerHost(host) ? "/" : "/order"
}

export function accountHref(hasSession: boolean): string {
  return hasSession ? "/cuenta/perfil" : "/cuenta/entrar"
}
